import {
    DTOCardFormField,
    FieldInCard,
} from 'app/types/form.types'
import {
    LongTermLeaseFeeStatus,
} from 'app/enums/label.enums'
import {
    LongTermLeaseFee,
    LongTermLeaseFeeObject,
} from '../LongTermLeaseFees.types'

export default ({
    fees,
    disabled,
    getAllowedValues,
    originalStatus,
}: {
    fees: LongTermLeaseFee[],
    disabled: boolean,
    originalStatus: LongTermLeaseFeeStatus,
    getAllowedValues: (value: Record<string, string>) => Record<string, string>,
}) => {
    const feesRow: FieldInCard<keyof LongTermLeaseFeeObject> = {
        title: 'Fees',
        className: 'fees',
        fields: [{
            name: 'fees',
            labelKey: 'AdditionalFeesUpdateDto.fees',
            componentName: 'Fees',
            value: fees,
            disabled,
            showSkyNetSpreadSheet: true,
        }],
    }

    const defaultFields: DTOCardFormField<keyof LongTermLeaseFeeObject>[] = [{
        title: 'General Information',
        className: 'general',
        fields: [
            {
                id: 'column1',
                fields: [
                    {
                        name: 'longTermLeaseFeesStatus',
                        labelKey: 'AdditionalFeesUpdateDto.additionalFeesStatus',
                        originalStatus,
                        componentName: 'StatusTransitionSelector',
                        showOutOfRangeOption: true,
                        useDropdown: true,
                        required: true,
                        allowedValues: getAllowedValues(LongTermLeaseFeeStatus),
                        disabled: true,
                    },
                    {
                        name: 'billingCompany',
                        labelKey: 'LaneBasicView.billingCompany',
                        componentName: 'BillingCompanyObjectSelector',
                        disabled,
                        required: true,
                    },
                ],
            },
            {
                id: 'column2',
                fields: [
                    {
                        name: 'validFrom',
                        labelKey: 'AdditionalFeesUpdateDto.validFrom',
                        componentName: 'DateSelect',
                        disabled,
                        required: true,
                    },
                    {
                        name: 'validTo',
                        labelKey: 'AdditionalFeesUpdateDto.validTo',
                        componentName: 'DateSelect',
                        disabled,
                        required: true,
                    },
                ],
            },
            {
                id: 'column3',
                className: 'commentColumn',
                fields: [
                    {
                        name: 'comment',
                        labelKey: 'AdditionalFeesUpdateDto.comment',
                        componentName: 'LongText',
                    },
                    {
                        name: 'commentForBilling',
                        labelKey: 'LaneFees.commentForBilling',
                        componentName: 'LongText',
                    },
                ],
            },
        ],
    }]

    return [
        ...defaultFields,
        feesRow,
    ]
}
